import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Home, SearchX } from 'lucide-react';

export function NotFound() {
  const { t } = useTranslation('common');

  return (
    <div className="max-w-2xl mx-auto mt-20">
      <Card>
        <CardHeader className="text-center">
          <div className="flex justify-center mb-4">
            <SearchX className="h-16 w-16 text-muted-foreground" />
          </div>
          <CardTitle className="text-3xl">{t('notFound.title')}</CardTitle>
          <CardDescription className="text-lg">
            {t('notFound.subtitle')}
          </CardDescription>
        </CardHeader>
        <CardContent className="text-center">
          <p className="text-muted-foreground">
            {t('notFound.description')}
          </p>
        </CardContent>
        <CardFooter className="flex justify-center">
          <Button asChild>
            <Link to="/">
              <Home className="mr-2 h-4 w-4" />
              {t('navigation.backToHome')}
            </Link>
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
}
